import { Directive, Input, OnChanges, SimpleChanges } from "@angular/core";

@Directive({
  selector: "[appUpdateFlash]",
})
export class UpdateFlashDirective implements OnChanges {
  @Input() public appHighlight: any;

  ngOnChanges(changes: SimpleChanges) {

  }
}
